import React, { useRef, useEffect, useState } from "react";
import "./LargeScreen.scss";
import { Col, Row, Image } from "antd";
import AngleSvg from "./AngleSvg";
import ModeAngleSvg from "./ModeAngleSvg";
import TopSvg from "./TopSvg";
import img from "../../assets/earth.svg";
import Area from "./Area";
import LeftTopData from "./LeftTopData";
import NodeData from "./NodeData";
import ProfitData from "./ProfitData";
import IncomeTable from "./IncomeTable";
import { getWindowInner } from "../../utils/index";

export default function LargeScreen() {
  const imgWrap = useRef();
  const mainContent = useRef();
  const [imgAttribute, setImgAttribute] = useState({
    with: 0,
    height: 0,
  });

  const [mianCotentAttribute, setMianCotentAttribute] = useState({
    with: 0,
    height: 0,
  });

  const [windowInner, setWindowInner] = useState(getWindowInner());

  useEffect(() => {
    imgWrapInfo();
    mianContentInfo();
    window.addEventListener("resize", handleResize);
    console.log("windowInner--1-", windowInner);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // 监听窗口变化
  const handleResize = (e) => {
    setWindowInner(getWindowInner());
    imgWrapInfo();
    mianContentInfo();
    console.log("windowInner--2-", windowInner);
  };

  // 地球自适应
  const imgWrapInfo = () => {
    const { clientHeight, clientWidth } = imgWrap?.current;
    setImgAttribute({
      with: clientWidth,
      height: clientHeight,
    });
  };

  // 左右两边宽高
  const mianContentInfo = () => {
    const { clientHeight, clientWidth } = mainContent?.current;
    setMianCotentAttribute({
      with: clientWidth,
      height: clientHeight,
    });
  };

  return (
    <>
      <div className="bg-wrap">
        <Row className="top">
          <Col span={24} className="center">
            <span className="title">华维网络大数据展示</span>
            <div className="top-svg">
              <TopSvg />
            </div>
          </Col>
        </Row>
        <Row className="content">
          {/* <AngleSvg cname="AngleSvg" />
          <AngleSvg cname="rightTop" />
          <AngleSvg cname="leftbottom" />
          <AngleSvg cname="rightbottom" /> */}
          <Row className="content-main" ref={mainContent}>
            <Col span={6} className="left">
              {/* 用户数 */}
              <div className="left-box">
                <div
                  className="user-count"
                  // style={{
                  //   height: mianCotentAttribute?.height * 0.5,
                  //   width: mianCotentAttribute?.width,
                  // }}
                >
                  <ModeAngleSvg cname="left-top" />
                  <ModeAngleSvg cname="right-top" />
                  <ModeAngleSvg cname="left-bottom" />
                  <ModeAngleSvg cname="right-bottom" />

                  <div className="count-data">
                    <LeftTopData />
                  </div>
                </div>
              </div>
              {/* 收益 */}
              <div className="income-wrap">
                <span className="income-title">收益</span>
                <div className="line line-left line1"></div>
                <div className="table-wrap">
                  <IncomeTable />
                </div>
              </div>
            </Col>
            <Col span={12} className="center">
              <div className="border-outside">
                <div className="border-inner">
                  {/* 背景地球 */}
                  <div className="img-wrap" ref={imgWrap}>
                    <Image
                      preview={false}
                      src={img}
                      className="img"
                      width={"100%"}
                      height={"100%"}
                      // width={imgAttribute.with - 100}
                      // height={imgAttribute.height - 100}
                      // style={{ marginTop: "50px" }}
                    />
                  </div>
                  {/* 3D地图 */}
                  <Area cname="area-content" arr={imgAttribute} />
                </div>
              </div>
            </Col>
            <Col span={6} className="right">
              <div className="right-box">
                <div className="user-count">
                  <ModeAngleSvg cname="left-top" />
                  <ModeAngleSvg cname="right-top" />
                  <ModeAngleSvg cname="left-bottom" />
                  <ModeAngleSvg cname="right-bottom" />

                  {/* 总节点 */}
                  <div className="node-data">
                    <NodeData cname="node-data__content" />
                  </div>
                </div>
                {/* 利润 */}
                <div className="profit-content">
                  <ProfitData />
                </div>
              </div>
            </Col>
          </Row>
        </Row>
      </div>
    </>
  );
}
